import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";
import moment from "moment";
import api from "../../../utils/api";
import close_modal from "./../../../assets/ic_close_wh.svg";
import Spinner from "../../../common/Spinner/Spinner";

export default function NotesTrailModal(props) 
{
    const [auditLog,setAuditLog] = useState([]);
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        if(props.isOpen)
        {
            if(props.nResourceInstanceId)
            {
                setLoading(true);
                let payload={nResourceInstanceId:props.nResourceInstanceId};
                api.getESPNotesLogByServiceId(payload)
                .then((d) => {
                    setAuditLog(d.data);
                    setLoading(false);
                });
            }            
        }        
      }, [props.isOpen]);

      const renderAuditTrail = () => {
        return auditLog.map((audit,i) => {
          return(
            <div className={`${i%2==0?'notes-trail-box-even':'notes-trail-box-odd'}`} key={i}>
              <div className="flex justify-content-between">
                <small className="notes-trail-text">{audit.refHH||audit.reqUser}</small>
                <small className="notes-trail-text">{moment(audit.dtCreated).format('lll')}</small>
              </div>
              <div className="conv-mt15">
              {audit.bSPEntry?
                (
                  <>
                    <div className="conv-mt15"><small className="notes-trail-text conv-mt15">Follow up on</small></div>
                    <div className="notes-trail-content-text conv-mt5">{audit.dtFollowupOn?moment(audit.dtFollowupOn).format('ll'):""}</div>
                    <div className="conv-mt15"><small className="notes-trail-text conv-mt15">Completed</small></div>
                    <div className="notes-trail-content-text conv-mt5">{audit.bHandled ? "Yes" : "No"}</div>
                  </>
                ):
                (
                  <><div><small className="notes-trail-text">Notes</small></div>
                  <div className="notes-trail-content-text conv-mt5" style={{whiteSpace: "pre-line"}}>
                    {audit.sNotesHH||audit.sNotes}
                  </div>
                  {audit.sModule?(""):
                  (
                    <>
                      <div className="conv-mt15"><small className="notes-trail-text">Followup Actions</small></div>
                      <div className="notes-trail-content-text conv-mt5" style={{whiteSpace: "pre-line"}}>
                        {audit.sFollowupAction}
                      </div>
                      <div className="conv-mt15"><small className="notes-trail-text conv-mt15">Follow up on</small></div>
                      <div className="notes-trail-content-text conv-mt5">{audit.dtFollowupOn?moment(audit.dtFollowupOn).format('ll'):""}</div>
                    </>
                  )} </>
                )}      
              </div>
            </div>
          )
        })
      }

  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={props.toggleModal}
      ariaHideApp={false}
    >
      <ModalContent className="lpm-notes-trail-modal">
          <div className="modal-header">
          <span className="modal-title">Notes Trail</span>
            <img
                alt="close"
                id="Close"
                src={close_modal}
                className="close modal-close"
                onClick={props.toggleModal}
            />
          </div>
        
        <div
            className={`modal-body notes-trail-content conv-pl25 conv-pr25 custom-scrollbar ${isLoading && "set-opacity"}`}
        >
            {isLoading && <Spinner className="top"/>}
            <div className="conv-mt10">                
                {auditLog.length>0?renderAuditTrail():<div className="notes-trail-box-even">No notes taken</div>}
            </div>
        </div>
      </ModalContent>
    </Modal>
  );
}